"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertReducer = exports.alertReducerActions = void 0;
const reducer_utils_1 = require("../Auth/providers/AuthProvider/reducer.utils");
const reducers = {
    addAlert: (state, payload) => {
        const alerts = [...state.alerts.filter(alert => alert.id !== payload.id), payload];
        return { alerts };
    },
    removeAlert: (state, payload) => {
        const alerts = state.alerts.filter(alert => alert.id !== payload.id);
        return { alerts };
    },
};
exports.alertReducerActions = (0, reducer_utils_1.createActions)(reducers);
exports.alertReducer = (0, reducer_utils_1.createReducer)(reducers);
